import { QbBusiness as api } from '../../utils/business/qbbusiness'
import { push } from 'react-router-redux'
import appConst from '../../constant/appConst'


export const GET_FOCUS_REQUEST = 'GET_FOCUS_REQUEST'
export const GET_FOCUS_SUCCESS = 'GET_FOCUS_SUCCESS'
export const GET_FOCUS_ERROR = 'GET_FOCUS_ERROR'

// Affichage jusqu'au bloc de texte après un carrousel, une playlist ou un un album
export const getFocus = (id) => dispatch => {
	dispatch({ type: GET_FOCUS_REQUEST })
	return api.getFocus(id, true, { extra: 'focus' })
		.then(response => {
			// Renvoi sur la racine en cas de retour noContent
			if (response.status === 'error' ||
				(response.containers && response.layouts && response.containers.length === 0 && response.layouts.length === 0)) {
				dispatch(push('/'))
				dispatch({ type: GET_FOCUS_ERROR, response })
			} else {
				let title = {}
				let image = {}
				let content = []
				let textPos = 0
				let blocFound = false
				if (typeof response.containers !== 'undefined') {
					(response.layouts || []).forEach(layout => {
						if (response.containers[layout.name]) {
							const container = response.containers[layout.name]
							switch (container.type) {
								case appConst.focus.layout.title:
									title = container
									break
								case appConst.focus.layout.imageFull:
									image = container
									break
								case appConst.focus.layout.text:
									if (blocFound) {
										textPos = textPos ? Math.min(textPos, layout.position) : layout.position
									}
									content.push({
										position: layout.position,
										...container
									})
									break
								case appConst.focus.layout.carousel:
									blocFound = true
									content.push({
										position: layout.position,
										...container,
										albums: container.albums ? {
											...container.albums,
											items: container.albums.items ? container.albums.items.map(album => ({
												id: album.id,
												title: album.title,
												artist: album.artist ? {
													id: album.artist.id,
													name: album.artist.name
												} : undefined,
												track_count: album.tracks_count,
												image: album.image ? album.image.small : undefined,
												released_at: album.released_at,
												sampleable: album.sampleable,
												hires: album.hires,
												genre: album.genre ? album.genre.id : undefined,
												award: album.awards && album.awards.length ? album.awards[0].name : undefined,
												description: album.description ? album.description.content : undefined
											})) : undefined
										} : undefined
									})
									break
								case appConst.focus.layout.album:
									blocFound = true
									const album = container.albums && container.albums.items && container.albums.items.length ?
										container.albums.items[0] : undefined
									if (album) {
										content.push({
											position: layout.position,
											type: container.type,
											album: {
												id: album.id,
												title: album.title,
												artist: album.artist ? {
													id: album.artist.id,
													name: album.artist.name
												} : undefined,
												track_count: album.tracks_count,
												image: album.image ? album.image.small : undefined,
												released_at: album.released_at,
												sampleable: album.sampleable,
												hires: album.hires,
												genre: album.genre ? album.genre.id : undefined,
												award: album.awards && album.awards.length ? album.awards[0].name : undefined,
												description: album.description ? album.description.content : undefined
											}
										})
									}
									break
								case appConst.focus.layout.playlist:
									blocFound = true
									break
								default:
									content.push({
										position: layout.position,
										...container
									})
							}
						}
					})
				}
				dispatch({
					type: GET_FOCUS_SUCCESS,
					id,
					title,
					image,
					content: content.filter(a => a.position <= textPos).sort((a, b) => a.position - b.position)
				})
			}
		})
		.catch(e => {
			push('/')
			dispatch({ type: GET_FOCUS_ERROR, e })
		})
}



// WEBPACK FOOTER //
// ./src/pages/focus/focusActions.js